import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';

import { AutoCompleteModule } from 'primeng/autocomplete';

import { PlatformSettingsComponent } from './platform-settings.component';
import { WalletComponent } from './wallet/wallet.component';

import { PlatformSettingsService } from './platform-settings.service';

import { routing } from './platform-settings.routing';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'src/app/shared/components/input-number/input-number.module';

@NgModule({
  declarations: [PlatformSettingsComponent, WalletComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    AutoCompleteModule,
    NgxPaginationModule,
    MatSlideToggleModule,
    routing,
    FieldsetModule,
    ButtonModule,
    InputNumberModule
  ],
  providers: [PlatformSettingsService],
})
export class PlatformSettingsModule {}
